export default __webpack_public_path__ + "static/media/expand.94d4b710.svg";